import PropTypes from 'prop-types'
import React, { Component } from 'react'
import classNames from 'classnames'

import { CaretBottomIcon } from 'components/Utils/Icons'
import { Secondary } from 'components/base/Button'
import Dropdown from 'components/base/Dropdown'
import { Name } from 'components/base/Text'

export default class Select extends Component {
  static propTypes = {
    value: PropTypes.any.isRequired,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
          .isRequired,
        description: PropTypes.string,
        key: PropTypes.string,
        value: PropTypes.any.isRequired,
      })
    ).isRequired,
    popoverPlacement: PropTypes.string.isRequired,
    className: PropTypes.any,
    buttonProps: PropTypes.any.isRequired,
    bodyProps: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
  }

  static defaultProps = {
    popoverPlacement: 'bottom',
    bodyProps: {},
    buttonProps: {},
  }

  render() {
    const {
      value,
      options,
      disabled,
      onChange,
      popoverPlacement,
      defaultValue,
      buttonProps,
      className,
      bodyProps,
    } = this.props
    const currentOption =
      options.find(option => option.value === value) || defaultValue

    return (
      <Dropdown
        itemToString={item => (item ? item.title : '')}
        onSelect={option => onChange(option.value)}
      >
        {({
          getRootProps,
          getButtonProps,
          getItemProps,
          highlightedIndex,
          isOpen,
        }) => (
          <Dropdown.Wrapper
            {...getRootProps({ refKey: 'innerRef' })}
            className={className}
          >
            <Secondary
              disabled={disabled}
              style={
                this.props.style ? { ...this.props.style } : { minWidth: 120 }
              }
              {...buttonProps}
              className={classNames('text-align-left', buttonProps.className)}
              {...getButtonProps()}
            >
              <div className="flexbox flexbox-align-center flexbox-space-between width-full">
                <div className="flexbox-grow padding-right-normal">
                  {currentOption.title}
                </div>
                <div className="flexbox-no-grow">
                  <CaretBottomIcon size={12} />
                </div>
              </div>
            </Secondary>
            {isOpen &&
              !disabled && (
                <Dropdown.Body placement={popoverPlacement} {...bodyProps}>
                  {options.map((option, index) => {
                    return (
                      <Dropdown.Item
                        selected={highlightedIndex === index}
                        key={option.key || option.title}
                        className="padding-vertical-medium"
                        style={{ lineHeight: 'inherit' }}
                        {...getItemProps({
                          item: option,
                          index,
                        })}
                      >
                        <div className="padding-right-normal">
                          <Name>{option.title}</Name>
                        </div>
                        {option.description && (
                          <div className="shade-10 font-weight-regular">
                            {option.description}
                          </div>
                        )}
                      </Dropdown.Item>
                    )
                  })}
                </Dropdown.Body>
              )}
          </Dropdown.Wrapper>
        )}
      </Dropdown>
    )
  }
}
